module.exports = "https://static.wmbcdn.com/uniweb/images/11e9703b836969bf02601c3cee65f3c4.svg";